export enum IncentiveWindowType {
  NoWindow = 0,
  DailyWindow = 1,
  SingleWindow = 2,
  PerLog = 3
}

export const IncentiveWindowTypeMapping: Record<IncentiveWindowType, string> = {
  [IncentiveWindowType.NoWindow]: 'Weekly',
  [IncentiveWindowType.DailyWindow]: 'Daily Window',
  [IncentiveWindowType.SingleWindow]: 'Weekly Window',
  [IncentiveWindowType.PerLog]: 'Per Log'
};
